<template>
  <fragment>
    <van-field :placeholder="disabled || readonly ? null : placeholder" :required="required"
      :value="text" readonly :label="label" :disabled="disabled"
      :right-icon="disabled || readonly ? null : 'arrow-down'"
      @click="() => !disabled && !readonly && (showPopup = true)">
      <van-loading v-if="loading" slot="right-icon" size="24px" />
    </van-field>
    <van-popup v-model="showPopup" round position="bottom" :get-container="getContainer">
      <van-picker :default-index="defaultIndex"
        show-toolbar :loading="loading"
        :columns="columns.map(item => ({
          text: item[textField],
          ...item
        }))"
        @cancel="showPopup = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </fragment>
</template>

<script>
import { Field, Popup, Picker, Loading } from 'vant'
import { Fragment } from 'vue-fragment'

export default {
  name: 'Picker',
  components: {
    'van-field': Field,
    'van-popup': Popup,
    'van-picker': Picker,
    'van-loading': Loading,
    Fragment
  },
  model: {
    event: 'change',
    prop: 'value'
  },
  props: {
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    loading: Boolean,
    readonly: Boolean,
    disabled: Boolean,
    value: {
      type: [String, Number],
      default: ''
    },
    valueField: {
      type: String,
      required: true
    },
    textField: {
      type: String,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    required: Boolean
  },
  data () {
    return {
      showPopup: false,
      localValue: this.value
    }
  },
  computed: {
    text () {
      for (const item of this.columns) {
        if (item[this.valueField] === this.value) {
          return item[this.textField]
        }
      }
      return ''
    },
    defaultIndex () {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i][this.valueField] === this.value) {
          return i
        }
      }
      return 0
    }
  },
  watch: {
    value (v) {
      if (this.localValue !== v) this.localValue = v
    },
    localValue (v) {
      if (this.value !== v) {
        this.$emit('change', v, this.text, this.defaultIndex)
      }
    }
  },
  methods: {
    getContainer () { return document.body },
    onConfirm (item) {
      this.localValue = item[this.valueField]
      this.showPopup = false
    }
  }
}
</script>
